import React, { ReactElement } from 'react';
import { useAtomValue } from 'jotai';
import { SingleSeriesAtom } from '../../../../../store/SeriesStore';
import './DesktopRating.scss';
import { AssetLinkGroup } from '../../../../../Models/AssetLinkGroup';




const DesktopRating = (): ReactElement => {
    const series = useAtomValue(SingleSeriesAtom);

    function renderResourcesCol() {

        //For now: Exclude asset links are not "MyAnimeList":
        const alg = series?.assetLinkGroups?.find(val=> val.name === "Digital");
        if(!alg) {
           return null;
        }

        const assetLinks = alg.assetLinks
            .filter(val =>val.url!==undefined && val.url !== null && val.url !=="")
            .filter(val=> val.name === "MyAnimeList");
        
        if(assetLinks.length === 0) {
            return null;
        }

        return (
            <div className='SeriesInfo-col'>
                <span className='SeriesInfo-key'>Resources</span>
                <div className='SeriesInfo-links'>
                    {assetLinks.map(l => (
                        <a key={l.name} href={l.url} target='_blank' rel='noopener noreferrer'
                           className='SeriesInfo-link'>
                            {l.name}
                        </a>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className='SeriesInfo'>
            <div className='SeriesInfo-title'>
                <h2>Series Info</h2>
            </div>
            <div className='SeriesInfo-table'>
                <div className='SeriesInfo-row'>
                    <div className='SeriesInfo-col'>
                        <span className='SeriesInfo-key'>Status</span>
                        <span className='SeriesInfo-value'>{series?.completionStatus?.toUpperCase()}</span>
                    </div>
                    <div className='SeriesInfo-col'>
                    <span className='SeriesInfo-key'>Rating</span>
                        <span className='SeriesInfo-value'>{series?.ageRating}</span>
                    </div>
                    {renderResourcesCol()}
                </div>
                {series?.genres?.length !== 0 && (
                    <div className='SeriesInfo-row'>
                        <div className='SeriesInfo-col'>
                            <span className='SeriesInfo-key'>Tags</span>
                            <div className='SeriesInfo-tags'>
                                {series?.genres?.map(g => (
                                    <span key={g.name} className='SeriesInfo-tag'>{g.name}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DesktopRating;
